$(document).ready(() => {
    $(".fil-cards .mini-promo").click(function () {
        let cardHref = $(this).find(".cta-section a").attr("href");
        if (cardHref !== undefined) {
            window.location = cardHref;
        }
        return false;
    });

    $(".fil-cards .image").click(function () {
        let cardHref = $(this).find(".cta-section a").attr("href");
        if (cardHref !== undefined) {
            window.location = cardHref;
        }
        return false;
    });
    let minipromoCards = $(".fil-cards .mini-promo");
    $.each(minipromoCards, function (index, element) {
        let cardHref = $(element).find(".cta-section a").attr("href");
        if (cardHref !== undefined) {
            $(element).css("cursor", "pointer");
        }
    });

    let imageCards = $(".fil-cards .image");
    $.each(imageCards, function (index, element) {
        let cardHref = $(element).find(".cta-section a").attr("href");
        if (cardHref !== undefined) {
            $(element).find(".image-header").css("cursor", "pointer");
        }
    });

    $(window).on("orientationchange", orientationchangeEvent);

    function orientationchangeEvent() {
        // Lazy loading main.css causes issues for Foundation's equalizer. Force
        // re-initialisation after the styling has finished loading.
        $(document).on("open.zf.reveal", "[data-reveal]", function () {
            if ($("[data-equalizer]", this).length > 0) {
                setTimeout(requalize, 100);
            }
        });
    }

    function requalize() {
        Foundation.reInit("equalizer");
    }
});
